import React from 'react';
import PropTypes from 'prop-types';
import {
  Form,
  FormGroup,
} from 'react-bootstrap';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';

import { messages } from './CcdaOptionsForm.i18n';
import { findCcdaExternalSystems } from '../../../redux/modules/health-summary/external-systems-mapper';

function Dropdown({
  field,
  externalSystemInvalid,
  change,
  initExternalSystemInvalid,
}) {
  const getLabel = (f) => f + 'Label';

  const externalSystems = useSelector((state) => state.externalSystems.externalSystems);
  const ccdaExternalSystems = findCcdaExternalSystems(externalSystems);
  ccdaExternalSystems.sort((a, b) => {
    const nameA = a.patientDisplayName.toUpperCase();
    const nameB = b.patientDisplayName.toUpperCase();
    if (nameA < nameB) {
      return -1;
    }
    return nameA > nameB ? 1 : 0;
  });

  const handleDropdownOnChange = (fldOnChange) => (values, dispatch, props) => {
    initExternalSystemInvalid();

    if (fldOnChange) {
      fldOnChange(values, dispatch, props);
    }
  }

  const handleDateFocus = () => {
    // Clear the recentVisitIndex selection
    change('radioValueField', 'daterange');
    change('recentVisitIndexField', -1);
  }

  /* eslint-disable */
  if (!ccdaExternalSystems || ccdaExternalSystems.length < 2) {
    return null;
  }
  
  return (
    <div className="row g-3 align-items-center mb-3 marginlr20">
    <div className="form-group mb-3">
    <FormGroup controlId={field.name}>
      <Form.Label  data-qa-item={'label_' + field.name}
        id={getLabel(field.name)}
      >
        <FormattedMessage {...messages.page.form.label.system} />
        
      </Form.Label>
      <Form.Select
        value={field.value || ''}
        onChange={handleDropdownOnChange(field.onChange)}
        onFocus={handleDateFocus}
        data-qa-item={field.name}
        role="button"
        aria-invalid={externalSystemInvalid}
        aria-describedby="selectMessage"
        className={externalSystemInvalid ? 'has-error is-invalid' : null}
      >
        <option data-qa-item="options_empty"></option>
        { ccdaExternalSystems.map(
          (system) => (
            <option key={'key_' + system.ifSystemId}
              value={system.ifSystemId}
              data-qa-item={'options_' + system.ifSystemId}
            >
              {system.patientDisplayName}
            </option>))}
      </Form.Select>
      { externalSystemInvalid &&
          <span id="externalSystem_required"
            className="invalid-feedback"
          >
            <FormattedMessage {...messages.page.form.error.required} />
          </span>}
      <span id="selectMessage" className="sr-only" >
        <FormattedMessage {...messages.page.form.label.systemHint} />
      </span>
    </FormGroup>
    </div>
    </div>
  );
}

Dropdown.propTypes = {
  ccdaExternalSystems: PropTypes.array, 
  field: PropTypes.object, 
  externalSystemInvalid: PropTypes.bool,
  change: PropTypes.func,
  initExternalSystemInvalid: PropTypes.func,
}

export default Dropdown;